import {
  OEButton,
  OEModal,
  OEText,
  flex,
  mr,
  mb,
  mt,
} from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import { useState, useEffect } from 'react';
import { View } from 'react-native';

export interface MessageConfirmDeleteModalProps {
  removeId: null | string;
  onRemoveConfirm: (id: string) => void;
  onCancel: () => void;
}
export const MessageConfirmDeleteModal = ({
  removeId,
  onRemoveConfirm,
  onCancel,
}: MessageConfirmDeleteModalProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!!removeId);
  }, [removeId]);

  return (
    <Modal visible={visible} onClose={onCancel}>
      <OEText style={mb(12)} fontSize={32} lineHeight={32} fontType="bold">
        Confirm Delete
      </OEText>

      <OEText style={[mt(5), mb(12)]} fontSize={18}>
        Are you sure you want to delete this message?
      </OEText>

      <View style={[flex('flex-row', 'justify-content-end'), mt(12)]}>
        <OEButton type="danger" style={mr(12)} onPress={onCancel}>
          Cancel
        </OEButton>
        <OEButton onPress={() => removeId && onRemoveConfirm(removeId)}>
          Confirm
        </OEButton>
      </View>
    </Modal>
  );
};
const Modal = styled(OEModal)`
  width: 600px;
  padding: 40px;
`;
